import { render, staticRenderFns } from "./Sparator.vue?vue&type=template&id=2e24a538&"
import script from "./Sparator.vue?vue&type=script&lang=js&"
export * from "./Sparator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports